import Axios from './axios_wrapper'

export function getIolModels () {
  return Axios({
    url: '/iols',
    method: 'GET'
  })
}

export function getIolPowers ({ id }) {
  return Axios({
    url: `/iols/${id}`,
    method: 'GET'
  })
}

export function getIolModelsCsv () {
  return Axios({
    url: `/admin/csv/iols`,
    method: 'GET'
  })
}

export function updateIolModelsCsv (data) {
  return Axios({
    url: `/admin/csv/iols`,
    method: 'POST',
    type: 'NOTYPE',
    data
  })
}

export function deleteIolModel ({id}) {
  return Axios({
    url: `/iols/${id}`,
    method: 'DELETE',
  })
}




//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/iols.js
// module id = null
// module chunks = 